import { render, staticRenderFns } from "./MatchByGender.vue?vue&type=template&id=6b2868f2&scoped=true&"
import script from "./MatchByGender.vue?vue&type=script&lang=js&"
export * from "./MatchByGender.vue?vue&type=script&lang=js&"
import style0 from "./MatchByGender.vue?vue&type=style&index=0&id=6b2868f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2868f2",
  null
  
)

export default component.exports